/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const FILTERED_GUIDE_MAX_SHOWS_PER_PAGE = 14;
export const FILTERED_GUIDE_FETCH_NUMBER = 2 * FILTERED_GUIDE_MAX_SHOWS_PER_PAGE;
